// ABOUTME: Plus icon with stroke style (not filled)
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const PlusStrokeIcon = ({ className = "", size = 12, color = "#6B7280" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.99984 1.91602V5.99935M5.99984 5.99935V10.0827M5.99984 5.99935H10.0832M5.99984 5.99935H1.9165"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
